import { normalizeAppPath } from "./normalizeAppPath";

export function pathMatches(routePath, pathname) {
  const p = normalizeAppPath(pathname);
  const r = normalizeAppPath(routePath);
  if (p === r) return true;
  if (r !== "/" && p.startsWith(`${r}/`)) return true;
  return false;
}
